'use client';

import { useCallback, useEffect, useState } from 'react';

export function useUserInteraction() {
  const [hasInteracted, setHasInteracted] = useState(false);

  const handleInteraction = useCallback(() => {
    setHasInteracted(true);
  }, []);

  useEffect(() => {
    if (hasInteracted) return;

    // Use passive listeners for better performance
    const options = { passive: true, once: true };

    // Reduced set of meaningful interactions
    const interactionEvents = ['click', 'scroll', 'keydown', 'touchstart'];

    // Add listeners with 'once' option for automatic cleanup
    for (const event of interactionEvents) {
      document.addEventListener(event, handleInteraction, options);
    }

    // Cleanup function
    return () => {
      for (const event of interactionEvents) {
        document.removeEventListener(event, handleInteraction);
      }
    };
  }, [hasInteracted, handleInteraction]);

  return hasInteracted;
}
